import { createRef, memo } from 'react';
import { Layout } from 'antd';
import MenuHeader from './MenuHeader';
import SideBarMenu from './SideBarMenu';
import { Menu as MenuIcon } from 'lucide-react';
import useWindowSize from '../../hooks/useWindowSize';
import MyDrawer from '../../components/myDrawer/MyDrawer';
import MyLucideIcon from '../../components/myIcon/MyLucideIcon';
import MyDividerDiffColor from '../../components/myDivider/MyDividerDiffColor';

const { Sider } = Layout;

const MainLayoutSideMenu = () => {
  const { isMobile } = useWindowSize();

  const refDrawer = createRef(null);

  const onCloseToggle = () => {
    refDrawer?.current?.closeDrawer();
  };

  return isMobile ? (
    <MyDrawer
      ref={refDrawer}
      className="ant_drawer_left_menu_mobile"
      closable={false}
      size="min(70%, 320px)"
      btnClassName="mobile_menu_btn"
      icon={<MyLucideIcon icon={MenuIcon} />}
      placement="left"
      btnStyle={{ width: 46 }}
      noExtraBtn
    >
      <MenuHeader onClick={onCloseToggle} />
      <MyDividerDiffColor />
      <SideBarMenu onSelect={onCloseToggle} />
    </MyDrawer>
  ) : (
    <Sider width={260} className="main_sider">
      <MenuHeader />
      <MyDividerDiffColor />
      <SideBarMenu />
    </Sider>
  );
};

export default memo(MainLayoutSideMenu);
